import iconUtil from '../utils/icon-util'
import * as misc from '../enums/misc'
import * as _ from 'lodash'
import labInfoService from '../services/pages-info-service'
import activityJsonUtil from '../utils/activityJson-util'
import q from 'q'
import * as staticURLS from '../enums/static-urls'

let YOUTUBE_PREVIEW_HIGH_QUALITY = 'hqdefault.jpg'

/**
 * This function is used to get the preview array for all the pages in resource
 * @param previewBatches
 * @param previews
 * @param detail
 * @param previewContentIds
 * @return promise
 */
let resolve = (previews, detail, previewContentIds, previewsIndex) => {
  let deferred = q.defer()
  let promises = []
  let count = 0
  let previewArr = []
  previewArr = previewArr.concat(previews)
  _.forEach(previewArr, (value) => {
    let result = resolvePreviewUrl(value, count)
    detail.previews.push(result.value)
    count = result.count
  })
  if (previewContentIds.length !== previews.length) {
    let contentIds = previews.map(p => p.contentId)
    previewContentIds
      .filter(x => !contentIds.includes(x)) // filter for missing
      .forEach(item => { // resolve each missing item
        promises.push(
          resolveActivityStockImage(detail.lppInfo.pages[item], item)
            .then((page) => {
              detail.previews.push(page.activityObj.defaultPreviewUrl)
              previews.push(page.activityObj)
            })
        )
      })
  }

  q.all(promises)
    .then(() => {
      if (count === previews.length) {
        detail.previews = []
      } else {
        detail.previews = sortPreviews(previews, previewsIndex)
      }
      deferred.resolve({
        count,
        detail,
        previews,
        previewContentIds
      })
    })
    .catch(deferred.reject)
  return deferred.promise
}

/**
 * function resolves the stock image for an activity if the activity does not have a preview Image
 * @param page
 */
let resolveActivityStockImage = (page, contentId) => {
  let deferred = q.defer()
  let promises = []
  let activityObj = {}
  page.webWidgets = (page.webWidgets) || {widgets: []}
  if (!_.isEmpty(page.webWidgets.widgets)) {
    let Id = Object.keys(page.webWidgets.widgets)[0]
    let activityJson = page.webWidgets.widgets[Id].activityJson
    if (_.isUndefined(activityJson)) {
      if (page.webWidgets.widgets[Id].hasOwnProperty('type')) {
        if (page.webWidgets.widgets[Id].type === 'YouTube') {
          activityObj = createActivityObj(contentId, getYouTubePreview(page.webWidgets.widgets[Id]), '')
        } else {
          activityObj = createActivityObj(contentId, iconUtil.resolve(misc.BLANK_IMAGE), '')
        }
      } else {
        activityObj = createActivityObj(contentId, iconUtil.resolve(misc.BLANK_IMAGE), '')
      }
      deferred.resolve({
        activityObj
      })
      return deferred.promise
    }
    let promise = labInfoService.extractInfoByActivity(activityJsonUtil.resolve(activityJson))
      .then((info) => {
        activityObj = createActivityObj(contentId, info.activityInfo.preview[0], info.activityInfo.preview)
      })
    promises.push(promise)
    q.all(promises)
      .then(() => {
        deferred.resolve({
          activityObj
        })
      })
    return deferred.promise
  } else {
    activityObj = createActivityObj(contentId, iconUtil.resolve(misc.BLANK_IMAGE), '')
    deferred.resolve({
      activityObj
    })
    return deferred.promise
  }
}

/**
 * Returns the previewUrl for a page, depending on what preview url is supplied in the profile response.
 * @param value
 * @param count
 * @returns {value, count}
 */
let resolvePreviewUrl = (value, count) => {
  value.previews = value.previews || {previews: []}
  if (!_.isUndefined(value.defaultPreviewUrl)) {
    return {
      value,
      count
    }
  } else if (value.previews[0]) {
    value.defaultPreviewUrl = value.previews[0]
    return {
      value,
      count
    }
  } else {
    count++
    value.defaultPreviewUrl = iconUtil.resolve(misc.IMAGE_NOT_FOUND)
    value.thumbnailError = true
    return {
      value,
      count
    }
  }
}
/**
 * Creates the activity object in the same format that the getProfile endpoint returns us child nodes.
 * @param ContentId
 * @param defaultPreviewUrl
 * @param previews
 * @returns {{ContentId: *, defaultPreviewUrl: *, previews: *}}
 */
let createActivityObj = (contentId, defaultPreviewUrl, previews) => {
  return {contentId, defaultPreviewUrl, previews}
}

/**
 * Sort previews by order returned from ContentServices.
 * @param previews
 * @param previewsIndex
 * @returns {previewArr: Array}
 */
let sortPreviews = (previews, previewsIndex) => {
  let sortedContentIds = previewsIndex.map((x) => x.contentId)

  return _.sortBy(previews, item => sortedContentIds.indexOf(item.contentId))
    .map(x => x.defaultPreviewUrl)
}

/**
 * Generates the previewIndex for the different pages.
 * @param previewContentIds
 * @param lppInfo
 * @returns [{contentId, index}]
 */
let getPreviewsIndex = (lppInfo) => {
  let pageGroups = Object.keys(lppInfo.pageGroups).filter(item => lppInfo.pageGroups[item].pages)
  let index = []
  let sortedPageGroups = pageGroups.map((y) => {
    let pageGroup = lppInfo.pageGroups[y]
    let previewContentIds = Object.keys(pageGroup.pages)
    let group = previewContentIds.map((x) => {
      return {
        contentId: x,
        index: pageGroup.pages[x].index
      }
    })
    group = _.sortBy(group, o => o.index)
    return {
      index: lppInfo.pageGroups[y].index,
      group: group
    }
  })
  index = _.sortBy(sortedPageGroups, o => o.index).map((x) => x.group)
  return _.flatten(index)
}

/**
 * Generates the preview image URI for YouTube pages
 */
let getYouTubePreview = (webWidget) => {
  return `${staticURLS.YOUTUBE_API + webWidget.videoId}/${YOUTUBE_PREVIEW_HIGH_QUALITY}`
}
export default {
  resolve,
  getPreviewsIndex,
  sortPreviews,
  resolveActivityStockImage
}
